import services from './services.js';
//组件
import complexSearch from './components/complex-search/index.vue';
import examinDialog from './components/examinDialog/index.vue';
import viewDialog from '../components/viewDialog/index.vue'; //查看弹窗

export default {
    mixins: [services],
    components: {
        'complex-search': complexSearch,
        viewDialog,
        examinDialog
    },
    created() {
        this.getList();
    },
    data() {
        return {
            /* 主表数据 */
            loading: false,
            lists: [], //表格内容
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中
            currentId: null, //当前选中的行id
            examineId: null,
            currentStatus: '', //当前选中的代理商的审核状态

            /* 高级搜索 */
            searchVisiable: false,
            filterData: {},

            /* 审核对话框 */
            examinDialogVisiable: false,
        };
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        },
        arrowClass() {
            return {
                'el-icon-arrow-down': !this.searchVisiable,
                'el-icon-arrow-up': this.searchVisiable
            };
        },
        bgStyle() {
            if (this.searchVisiable) {
                return {
                    'backgroundColor': '#e8e8e8'
                };
            }
            return {
                'backgroundColor': '#fff'
            };
        }
    },
    methods: {
        selectRow(row) {
            // if (!row) return;
            // this.currentId = row.CustomerId;
            // this.examineId = row.Id;
            // this.currentStatus = row.Agent_Status;
            // this.ApplyType = row.ApplyType
        },
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getList();
        },
        toggleSearch() {
            this.searchVisiable = !this.searchVisiable;
        },
        complexSearch(data) {
            this.filterData = data;
            this.getList();
        },
        resetFilterData() {
            this.filterData = {};
            this.getList();
        },
        // 查看
        showDetails(row) {
            this.$refs.viewDialog.show({
                Id: row.CustomerId,
                title: '查看',
            })
        },
        // 审核
        showExaminDialog(row) {
            this.$refs.viewDialog.show({
                Id: row.CustomerId, //对象Id
                title: '代理商审核',
                isExamine: true, //审核入口
            })
            // if (this.ApplyType == 1) {
            //     // 转正审核
            //     this.$refs.viewDialog.show({
            //         Id: this.currentId, //对象Id
            //         examineId: this.examineId, //正式id
            //         title: '代理商审核',
            //         isReadOnly: true,
            //         isExamine: true, //审核入口
            //     })
            // } else if (this.ApplyType == 2) {
            //     // 升级审核
            //     this.$refs.examinDialog.show({
            //         Id: this.examineId,
            //         title: '升级审核',
            //         CustomerId: this.currentId
            //     })
            // }
        },
        delAgent() {
            if (this.currentId === null) {
                this.$notify({
                    title: '警告',
                    message: '请先选择要删除的客户',
                    type: 'warning'
                });
                return;
            }

            if (this.currentStatus !== '审核已通过') {
                this.$notify({
                    title: '警告',
                    message: '只能对审核已通过的代理商进行删除审核操作',
                    type: 'warning'
                });
                return;
            }

            this.$confirm('此操作将永久删除该申请转正的代理商, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.req_delAgent({
                    Id: this.currentId
                });
            }).catch(() => {});
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/AgentAudit/vm.js